import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as Chart from 'chart.js';
import * as moment from 'moment';
import { AgentService } from 'src/app/agent/services/agent.service';
import { BaseComponent } from 'src/app/system-common/base/base.component';
import { SettingService } from 'src/app/system-common/services/setting.service';

@Component({
  selector: '',
  template: '',
})
export class AgentPerformanceHandlerComponent extends BaseComponent<AgentService> implements OnInit {
  @ViewChild('dateTimeRange') dateTimeRange: any;
  @ViewChild('frequncy') frequncy: ElementRef;
  @Output() closeChart = new EventEmitter<string>();

  public dateTimeRange1: Date[];
  public lineGraph: boolean;
  public barGraph: boolean;
  public currentSelectedTheme;

  frequency: string;
  currFreqModel: any;
  modelSave: boolean;
  modalSaveCheck: boolean;
  model1: boolean;
  model2: boolean;
  model3: boolean;
  FromDate;
  ToDate;
  inlineChartEvent: string;
  agentPerformanceBarChartTargetData = [];
  agentPerformanceBarChartActualData = [];
  agentPerformanceLineChartTargetData = [];
  agentPerformanceLineChartActualData = [];
  allocationPercLabels = [];

  agentPerformanceBarChartLabels: any = [];
  agentPerformanceLineChartLabels: any = [];
  productionSummary: any;
  event: any;
  productionName: any;
  quarterarr: any[];
  montharr: any[];
  month: any;
  year: any;
  init: boolean;
  agentPerformanceGraph: Chart;
  currQuar: any;
  startDate: any;
  endDate: any;
  isCustom: boolean;
  isBtnCustomClicked: boolean;
  productionNameArr: any = [];

  constructor(agentService: AgentService, public settingService: SettingService, public router: Router) {
    super(agentService);
    this.modelSave = false;
    this.modalSaveCheck = false;
    this.model1 = false;
    this.model2 = false;
    this.model3 = false;
    this.inlineChartEvent = 'Q';
    this.event = 'Q';
    this.quarterarr = ['Jan,Feb,Mar', 'Apr,May,Jun', 'Jul,Aug,Sep', 'Oct,Nov,Dec'];
    this.montharr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    this.month = new Date(Number(this.settingService.getSessionStorageValue('BatchDate'))).getMonth() + 1;
    this.year = new Date(Number(this.settingService.getSessionStorageValue('BatchDate'))).getFullYear();
    this.init = true;
    this.isCustom = false;
    this.barGraph = true;
    this.lineGraph = false;
    this.isBtnCustomClicked = false;
  }

  ngOnInit() {
    this.currentSelectedTheme = this.settingService.getSessionStorageValue('currentSelectedTheme');
    if (
      (this.currentSelectedTheme != undefined || this.currentSelectedTheme != null) &&
      this.currentSelectedTheme.endsWith('.css')
    ) {
      this.currentSelectedTheme = this.currentSelectedTheme.replace('.css', '');
    }
    this.getProductionName();
  }

  getProductionName() {
    this.service.getProductionName().subscribe(
      (body) => {
        let lookupBody: any = body;
        this.productionNameArr = [];
        if (lookupBody['data']['values'].length > 0) {
          for (let i = 0; i < lookupBody['data']['values'].length; i++) {
            this.productionNameArr.push(lookupBody['data']['values'][i]);
            if (lookupBody['data']['values'][i]['cd'] == this.productionNameArr[0].cd) {
              lookupBody['data']['values'][i]['isProductionSelected'] = true;
              lookupBody['data']['values'][i]['isPerformanceSelected'] = true;
            } else {
              lookupBody['data']['values'][i]['isProductionSelected'] = false;
              lookupBody['data']['values'][i]['isPerformanceSelected'] = false;
            }
          }
        }
        this.initPerformanceGraph(this.inlineChartEvent, lookupBody['data']['values'][0].cd, undefined);
      },
      (error) => {
        console.log('Error:', error);
      }
    );
  }

  onSelectDateRange() {
    $('#myPerForm').toggle();
    this.isBtnCustomClicked = true;
    this.isCustom = true;
  }

  initPerformanceGraph(chartEvent, productNameDesc, isGraphShow) {
    if (this.isBtnCustomClicked) {
      $('#myPerForm').toggle();
      this.isBtnCustomClicked = false;
    }

    if (chartEvent) this.event = chartEvent;
    if (productNameDesc) this.productionName = productNameDesc;

    if (isGraphShow !== undefined && isGraphShow !== null) {
      this.productionNameArr.forEach((product) => {
        product.isPerformanceSelected = product.cd === productNameDesc;
      });
    }

    this.inlineChartEvent = this.event;

    this.agentPerformanceBarChartTargetData = [];
    this.agentPerformanceBarChartActualData = [];
    this.agentPerformanceBarChartLabels = [];
    this.agentPerformanceLineChartTargetData = [];
    this.agentPerformanceLineChartActualData = [];
    this.agentPerformanceLineChartLabels = [];
    this.productionSummary = [];
    this.allocationPercLabels = [];

    const monthLabel = this.montharr[this.month - 1];
    const prevMonthLabel = this.montharr[(this.month + 10) % 12];

    if (this.event === 'M') {
      this.allocationPercLabels = [
        `${this.service.getMultilingualLabel('Actual')} ${prevMonthLabel}`,
        `${this.service.getMultilingualLabel('Target')} ${monthLabel}`,
      ];
    } else if (this.event === 'Q') {
      this.allocationPercLabels = [
        this.service.getMultilingualLabel('Target'),
        this.service.getMultilingualLabel('Actual'),
      ];
      this.currQuar = Math.ceil(this.month / 3);
    } else if (this.event === 'Y') {
      this.allocationPercLabels = [
        `${this.service.getMultilingualLabel('Actual')} ${this.year - 1}`,
        `${this.service.getMultilingualLabel('Target')} ${this.year}`,
      ];
    }

    const apiCall = this.isCustom
      ? this.service.getCustomAgentPerformance(
          this.productionName,
          moment(this.startDateData(this.dateTimeRange.nativeElement.value)).format('YYYY-MM-DD'),
          moment(this.endDateData(this.dateTimeRange.nativeElement.value)).format('YYYY-MM-DD'),
          this.event,
          this.month,
          this.year
        )
      : this.service.getAgentPerformance(this.productionName, this.month, this.year);

    apiCall.subscribe(
      (response) => {
        const insertedMonthYear: string[] = [];
        const respData = JSON.parse(JSON.stringify(response));
        const data = this.isCustom
          ? respData?.data?.CustomProductionAchievement
          : respData?.data?.ProductionAchievement;

        if (!data || Object.keys(data).length === 0) {
          this.barGraph = false;
          this.lineGraph = false;
          return;
        }

        for (let [label, entry] of Object.entries(data)) {
          let target: number;
          let actual: number;
          let year: string;
          let month: number;
          let monthName: string;

          if (this.isCustom && Array.isArray(entry)) {
            target = parseFloat(entry[0]);
            actual = parseFloat(entry[1]);

            const parts = label.split('/');
            year = parts[0];
            month = parseInt(parts[1], 10);
            monthName = this.montharr[month - 1];
          } else {
            target = parseFloat(entry['targetValue']);
            actual = parseFloat(entry['actualValue']);
            year = entry['productionYear'];
            month = entry['productionMonth'];
            monthName = this.montharr[month - 1];
          }

          const monthYearKey = `${year}_${month}`;

          // Line Chart labels and data
          if (this.event === 'M') {
            const lineLabel = `${monthName} ${year}`;
            if (!this.agentPerformanceLineChartLabels.includes(lineLabel)) {
              this.agentPerformanceLineChartLabels.push(lineLabel);
            }

            if (insertedMonthYear.includes(monthYearKey)) {
              const idx = insertedMonthYear.indexOf(monthYearKey);
              this.agentPerformanceLineChartActualData[idx] += actual;
            } else {
              insertedMonthYear.push(monthYearKey);
              this.agentPerformanceLineChartTargetData.push(target);
              this.agentPerformanceLineChartActualData.push(actual);
            }
          } else {
            const lineLabel = label;
            this.agentPerformanceLineChartLabels.push(lineLabel);
            this.agentPerformanceLineChartTargetData.push(target);
            this.agentPerformanceLineChartActualData.push(actual);
          }

          // Bar chart (quarterly)
          const monthInQuarter = Math.ceil(month / 3);
          if (
            this.isCustom ||
            (this.event === 'M' && month === this.month) ||
            (this.event === 'Q' && monthInQuarter === this.currQuar) ||
            this.event === 'Y'
          ) {
            if (!insertedMonthYear.includes(monthYearKey)) {
              insertedMonthYear.push(monthYearKey);
              this.agentPerformanceBarChartTargetData.push(target);
              this.agentPerformanceBarChartActualData.push(actual);
              const barLabel = `${monthName} ${year}`;
              if (!this.agentPerformanceBarChartLabels.includes(barLabel)) {
                this.agentPerformanceBarChartLabels.push(barLabel);
              }
            } else {
              const idx = insertedMonthYear.indexOf(monthYearKey);
              this.agentPerformanceBarChartActualData[idx] += actual;
            }
          }
        }

        // Call the chart function once after loop
        if (this.event === 'Q') {
          this.lineGraph = false;
          this.barGraph = true;
          setTimeout(() => {
            this.barChartBrowser();
          }, 10);
        } else {
          this.lineGraph = true;
          this.barGraph = false;
          setTimeout(() => {
            this.lineChartBrowser();
          }, 10);
        }
      },
      (error) => {
        console.error('Error fetching performance:', error);
      }
    );
  }

  lineChartBrowser() {
    this.lineGraph = true;
    this.barGraph = false;
    if (this.agentPerformanceGraph) {
      this.agentPerformanceGraph.destroy();
    }

    this.agentPerformanceGraph = new Chart('lineagentPerformanceCharts', {
      type: 'line',
      data: {
        labels: this.agentPerformanceLineChartLabels,
        datasets: [
          {
            data: this.agentPerformanceLineChartTargetData,
            label: this.service.getMultilingualLabel('Target'),
            borderColor: '#E78AC3',
            fill: false,
            barPercentage: this.agentPerformanceLineChartTargetData.length > 1 ? 0.8 : 0.5,
            categoryPercentage: this.agentPerformanceLineChartTargetData.length > 1 ? 0.6 : 0.3,
          },
          {
            data: this.agentPerformanceLineChartActualData,
            label: this.service.getMultilingualLabel('Actual'),
            borderColor: '#8DA0CB',
            fill: false,
            barPercentage: this.agentPerformanceLineChartActualData.length > 1 ? 0.8 : 0.5,
            categoryPercentage: this.agentPerformanceLineChartActualData.length > 1 ? 0.6 : 0.3,
          },
        ],
      },
      options: {
        title: {
          text: null,
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              let label = data.datasets[tooltipItem.datasetIndex].label;
              let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
              return ' ' + label + ' : ' + value.toLocaleString();
            },
          },
          bodyFontFamily: 'montserratregular, Arial, Helvetica, sans-serif',
        },
        legend: {
          align: 'center',
          position: 'bottom',
          labels: {
            fontColor: this.currentSelectedTheme == 'dark' ? '#fff' : '#000',
            fontFamily: 'montserratregular, Arial, Helvetica, sans-serif',
          },
        },
        scales: {
          xAxes: [
            {
              ticks: {
                fontColor: this.currentSelectedTheme == 'dark' ? '#fff' : '#000',
                fontFamily: 'montserratregular, Arial, Helvetica, sans-serif',
              },
            },
          ],
          yAxes: [
            {
              display: true,
              ticks: {
                beginAtZero: true,
                min: 0,
                callback: function (value) {
                  return value.toLocaleString();
                },

                fontColor: this.currentSelectedTheme == 'dark' ? '#fff' : '#000',
                fontFamily: 'montserratregular, Arial, Helvetica, sans-serif',
              },
              scaleLabel: {
                display: false,
              },
            },
          ],
        },
        plugins: {
          datalabels: false,
        },
      },
    });
  }

  barChartBrowser() {
    this.lineGraph = false;
    this.barGraph = true;
    if (this.agentPerformanceGraph) {
      this.agentPerformanceGraph.destroy();
      this.agentPerformanceGraph = null;
    }
    this.agentPerformanceGraph = new Chart('barPerformanceChart', {
      type: 'bar',
      data: {
        labels: this.agentPerformanceBarChartLabels,
        datasets: [
          {
            label: this.service.getMultilingualLabel('Target'),
            backgroundColor: '#E78AC3',
            fill: true,
            data: this.agentPerformanceBarChartTargetData,
            categoryPercentage: this.agentPerformanceBarChartTargetData.length == 1 ? 0.2 : 0.4,
            barPercentage: this.agentPerformanceBarChartTargetData.length == 1 ? 0.9 : 0.9,
          },
          {
            label: this.service.getMultilingualLabel('Actual'),
            backgroundColor: '#8DA0CB',
            fill: true,
            data: this.agentPerformanceBarChartActualData,
            categoryPercentage: this.agentPerformanceBarChartActualData.length == 1 ? 0.2 : 0.4,
            barPercentage: this.agentPerformanceBarChartActualData.length == 1 ? 0.9 : 0.9,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        onClick: (e, activeEls) => {},
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              let label = data.datasets[tooltipItem.datasetIndex].label || '';
              let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
              return `${label}: ${value.toLocaleString()}`;
            },
          },
          bodyFontFamily: 'montserratregular, Arial, Helvetica, sans-serif',
        },

        scales: {
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: '',
                fontColor: this.currentSelectedTheme == 'dark' ? '#fff' : '#000',
                fontFamily: 'montserratregular, Arial, Helvetica, sans-serif',
              },
              gridLines: {
                color: this.currentSelectedTheme === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.1)',
                zeroLineColor: this.currentSelectedTheme === 'dark' ? '#fff' : 'rgba(10, 10, 10, 0.2)',
                drawBorder: true,
                lineWidth: 1,
              },
              ticks: {
                fontColor: this.currentSelectedTheme == 'dark' ? '#fff' : '#000',
                fontFamily: 'montserratregular, Arial, Helvetica, sans-serif',
              },
            },
          ],
          yAxes: [
            {
              display: true,
              ticks: {
                beginAtZero: true,
                min: 0,
                callback: function (value) {
                  return value.toLocaleString();
                },
                fontColor: this.currentSelectedTheme == 'dark' ? '#fff' : '#000',
                fontFamily: 'montserratregular, Arial, Helvetica, sans-serif',
              },
              gridLines: {
                color: this.currentSelectedTheme === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.1)',
                zeroLineColor: this.currentSelectedTheme === 'dark' ? '#fff' : 'rgba(10, 10, 10, 0.2)',
                drawBorder: true,
                lineWidth: 1,
              },
              scaleLabel: {
                display: true,
                labelString: '',
                fontColor: this.currentSelectedTheme == 'dark' ? '#fff' : '#000',
                fontFamily: 'montserratregular, Arial, Helvetica, sans-serif',
              },
            },
          ],
        },
        plugins: {
          datalabels: false,
          plotpadding: 0.2,
          plotBackgroundColor: '#F4F4F4',
          plotBorderWidth: null,
          plotShadow: false,
          credits: {
            enabled: false,
          },
          title: {
            display: true,
            text: null,
          },
        },
        legend: {
          display: true,
          onClick: () => {},
          position: 'bottom',
          labels: {
            fontColor: this.currentSelectedTheme == 'dark' ? '#fff' : '#000',
            fontFamily: 'montserratregular, Arial, Helvetica, sans-serif',
            generateLabels: () => {
              var result = [];

              this.allocationPercLabels.forEach((label, i) => {
                if (this.allocationPercLabels[i][0] == this.service.getMultilingualLabel('Target')[0])
                  result.push({
                    text: this.allocationPercLabels[i],
                    fillStyle: '#E78AC3',
                  });
                else
                  result.push({
                    text: this.allocationPercLabels[i],
                    fillStyle: '#8DA0CB',
                  });
              });
              return result;
            },
          },
        },
      },
    });
  }

  startDateData(data) {
    data = data.split(' ', 3);
    if (this.frequency != null || this.frequency != undefined) {
      let sdate = new Date(data[0]);
      return sdate;
    }
  }

  endDateData(data) {
    data = data.split(' ', 3);
    if (this.frequency != null || this.frequency != undefined) {
      let edate = new Date(data[2]);
      return edate;
    }
  }

  onSaveDate() {
    this.openModal('agentPerformanceModal');
  }

  save(data, frequency) {
    if ((this.frequency == null && this.frequency == undefined) || this.frequency == 'Select') {
      this.modelSave = true;
      this.onSaveDate();
    } else if (
      this.dateTimeRange.nativeElement.liveValue == '' ||
      this.dateTimeRange.nativeElement.liveValue == undefined
    ) {
      this.modelSave = true;
      this.onSaveDate();
    } else {
      const diffDays = this.calculateDiff(this.dateTimeRange.nativeElement.value);
      if (diffDays >= 30 && diffDays <= 90 && frequency === 'D') {
        this.model1 = true;
        this.model2 = false;
        this.model3 = false;
        this.onSaveDate();
      } else if (diffDays > 90 && diffDays <= 365 && (frequency === 'D' || frequency === 'Weekly')) {
        this.model1 = false;
        this.model2 = true;
        this.model3 = false;
        this.onSaveDate();
      } else if (diffDays > 365 && frequency != 'Q') {
        this.model1 = false;
        this.model2 = false;
        this.model3 = true;
        this.onSaveDate();
      } else {
        $('#myPerForm').hide();
        this.closeMyModal();
        this.initPerformanceGraph(this.frequency, undefined, undefined);
      }
    }
  }

  clearData() {
    if (this.dateTimeRange && this.dateTimeRange.nativeElement) {
      this.dateTimeRange.nativeElement.value = '';
      this.dateTimeRange.nativeElement.liveValue = '';
    }
    this.frequency = null;
    const frequencySelect = document.getElementById('inputGroupSelect01') as HTMLSelectElement;
    if (frequencySelect) {
      frequencySelect.selectedIndex = 0;
    }

    this.isCustom = false;
    this.isBtnCustomClicked = false;

    $('#myPerForm').hide();
    // this.closeMyModal();

    this.initPerformanceGraph(this.inlineChartEvent, this.productionName, undefined);
  }

  clear() {
    $('#agentPerformanceModal').hide();
  }

  closeMyModal() {
    $('#myPerForm').hide();
    this.isBtnCustomClicked = !this.isBtnCustomClicked;
  }

  closePopUpModal() {
    this.closeModal('agentPerformanceModal');
  }

  selectedRange(value) {
    if (
      this.dateTimeRange != null &&
      this.dateTimeRange != undefined &&
      value.target.value != undefined &&
      value.target.value != ' '
    ) {
      this.frequency = value.target.value;
      this.modelSave = false;
      const diffDays = this.dateTimeRange;
      if (diffDays >= 30 && diffDays <= 90 && value.target.value === 'D') {
        this.model1 = true;
        this.model2 = false;
        this.model3 = false;
        this.onSaveDate();
      } else if (
        diffDays > 90 &&
        diffDays <= 365 &&
        (value.target.value === 'D' || value.target.value === 'Weekly')
      ) {
        this.model1 = false;
        this.model2 = true;
        this.model3 = false;
        this.onSaveDate();
      } else if (diffDays > 365 && value.target.value != 'Q') {
        this.model1 = false;
        this.model2 = false;
        this.model3 = true;
        this.onSaveDate();
      }
    }
  }

  calculateDiff(data) {
    data = data.split(' ', 3);
    let firstDate = data[0];
    let secondDate = data[2];

    var date1 = new Date(firstDate);
    var date2 = new Date(secondDate);
    let date = date1;
    let currentDate = date2;
    let days = Math.floor((currentDate.getTime() - date.getTime()) / 1000 / 60 / 60 / 24);
    return days;
  }

  // Close the Chart on click of the close button
  onCloseClick() {
    this.closeChart.emit(Chart);
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    // super.ngOnDestroy();
    this.service.clear();
  }
}
